import { render, staticRenderFns } from "./pdf.vue?vue&type=template&id=2a32a122"
import script from "./pdf.js?vue&type=script&lang=js&external"
export * from "./pdf.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports